export var BUTTON_VARIANT = {
  GHOST: "ghost",
  GHOST_INVERTED: "ghostInverted",
  NAKED: "naked"
};
export var BUTTON_STATUS = {
  SUCCESS: "success",
  ERROR: "error"
};
export var BUTTON_TYPES = {
  BUTTON: "button",
  RESET: "reset",
  SUBMIT: "submit",
  MENU: "menu"
};